export function weibanPhones(data) {
  return {
    type: 'WEIBAN_PHONE',
    ...data
  };
}

export function weibanPhonesCompletion(error, data) {
  return {
    type: 'WEIBAN_PHONE_COMPELTION',
    error,
    data
  };
}

export function weibanCheckPhone(value) {
  return {
    type: 'WEIBAN_PHONE_CHECK',
    value: value
  };
}

// 订单

export function weibanOrder(query) {
  return {
    type:'WEIBAN_ORDER',
    query,
    willReload: query.willReload,
  }
  
}

export function weibanOrderCompletion(error,data) {
  return {
    type:'WEIBAN_ORDER_COMPELTION',
    error,
    data
  }
}
export function weibanStoreOrder(query) {
  return {
    type:'WEIBAN_STORE_ORDER',
    query,
    willReload: query.willReload,
  }
  
}

export function weibanStoreOrderCompletion(error,data) {
  return {
    type:'WEIBAN_STORE_ORDER_COMPELTION',
    error,
    data
  }
}


export function weibanOrderDetail(query) {
  return {
     type:'WEIBAN_ORDER_DETAIL',
     query
  }
}


export function weibanOrderDetailCompletion(error,data) {
  return {
     type:'WEIBAN_ORDER_DETAIL_COMPELTION',
     error,
     data
  }
}